import { EditOutlined } from '@ant-design/icons';
import { useInViewport } from 'ahooks';
import { Button, Popover } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FormEntry } from '@/presentation/components/form';
import { FilterArray } from '@/presentation/components/form/setting/filter-array';
import styles from '@/presentation/components/tds-form/tds-fields-filter/index.module.scss';

export interface FilterPanelProps {
  entries: FormEntry[];
  defaultSelectedEntries: FormEntry[];
  onSelectedChange?: (selectedEntries: FormEntry[]) => void;
  style?: React.CSSProperties;
  renderByGroup?: boolean;
}

export const FilterPanel = observer((props: FilterPanelProps) => {
  const { entries, defaultSelectedEntries, onSelectedChange, style } = props;
  const [visible, setVisible] = useState(false);
  const triggerRef = useRef<any>();
  const [inViewport] = useInViewport(triggerRef);

  const popMenu = useMemo(() => (
    <FilterArray
      entries={entries}
      defaultSelectedEntries={defaultSelectedEntries}
      onSelectedChange={(entries) => {
        onSelectedChange?.(entries);
      }}
      renderByGroup={props.renderByGroup}
    />
  ), [entries, defaultSelectedEntries]);

  useEffect(() => {
    // 优化交互体验，当按钮不可见时候，主动隐藏面板，避免遮挡
    if (!inViewport) {
      // todo
      // setVisible(false);
    }
  }, [inViewport]);

  return (
    <Popover
      visible={visible}
      onVisibleChange={visible => setVisible(visible)}
      content={popMenu}
      trigger='click'
      placement='bottomLeft'
      destroyTooltipOnHide
      overlayClassName={styles.overlay}
    >
      <Button icon={<EditOutlined />} style={style} ref={triggerRef}>编辑字段</Button>
    </Popover>
  );
});
